import { fetchFromVolatileServer } from "../utils/fetchFromVolatileServer";
import { getAundsV1Url } from "../utils/url";

export type InstagramPost = {
  id: string;
  caption: string | null;
  alt_text: string | null;
  media_type: "image" | "video" | "carousel_album";
  media_url: string;
  permalink: string;
  timestamp: string;
  thumbnail_url: string | null;
  children:
    | {
        id: string;
        media_url: string;
        media_type: "image" | "video";
        thumbnail_url: string | null;
        alt_text: string | null;
      }[]
    | null;
};

type GetInstagramFeedProps = {
  perPage: number;
  page: number;
  offset: number;
};

export const getInstagramFeed = async ({ perPage, page, offset }: GetInstagramFeedProps) => {
  const urlParams = new URLSearchParams();
  urlParams.append("per_page", perPage.toString());
  urlParams.append("page", page.toString());
  urlParams.append("offset", offset.toString());

  const instaRes = await fetchFromVolatileServer(
    getAundsV1Url() + "/insta/feed?" + urlParams.toString(),
  );
  return (await instaRes.json()) as { items: InstagramPost[]; total: number };
};

export type InstagramSettings = {
  acf: {
    box: null | {
      show_card_box: false;
      show_box_shadow: false;
      show_border_radius: false;
    };
    follow_button_type:
      | null
      | "secondary-centered"
      | "primary-bottom"
      | "secondary-right";
    show_loadmore: null | boolean;
    max_pages: null | number;
  };
};

export const getInstagramSettings = async () => {
  const instaRes = await fetchFromVolatileServer(
    getAundsV1Url() + "/insta/settings",
  );
  return (await instaRes.json()) as InstagramSettings;
};

export type InstagramProfile = {
  url: string;
};
export const getInstagramProfile = async () => {
  const instaRes = await fetchFromVolatileServer(
    getAundsV1Url() + "/insta/profile?",
  );
  return (await instaRes.json()) as InstagramProfile;
};
